import * as React from 'react'

export const ChevronDownIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="18"
      height="11"
      viewBox="0 0 18 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M8.10156 9.89844L0.601562 2.39844C0.09375 1.92969 0.09375 1.10938 0.601562 0.640625C1.07031 0.132812 1.89062 0.132812 2.35938 0.640625L9 7.24219L15.6016 0.640625C16.0703 0.132812 16.8906 0.132812 17.3594 0.640625C17.8672 1.10938 17.8672 1.92969 17.3594 2.39844L9.85938 9.89844C9.39062 10.4062 8.57031 10.4062 8.10156 9.89844Z"
        fill="currentColor"
      />
    </svg>
  )
}
